import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShoppingBag2"><Path fillRule="evenodd" clipRule="evenodd" d="M7.9982 6C7.9982 3.79086 9.78906 2 11.9982 2C14.2073 2 15.9982 3.79086 15.9982 6V7H18.3953L20.6175 22H3.37891L5.60113 7H7.9982V6ZM9.4982 7H14.4982V6C14.4982 4.61929 13.3789 3.5 11.9982 3.5C10.6175 3.5 9.4982 4.61929 9.4982 6V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag2;
